import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import camera from '../assets/images/svg/camera.svg';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { debounce } from "lodash";
import CustomUploadAdapter from "../components/adapterclass/CustomUploadAdapter";
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import Loader from './Loader/Loader';
import { toast } from 'react-toastify';
import PaginationC from './pagination';

const Blogs = (props) => {

  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [viewModalShow, setViewModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [viewData, setViewData] = useState([])
  const serverURL = getServerURL()
  const fileInputRef = useRef(null);

  const [states, setStates] = useState({})
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState([])
  const [deleteData, setDeleteData] = useState();
  const [loading, setLoading] = useState(true);
  const [subLoader, setSubLoader] = useState(false);
  const [mode, setMode] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [paginationData, setPaginationData] = useState({})
  const [page, setPage] = useState(1)

  useEffect(() => {
    getBlockList();
  }, [searchText, page]);

  useEffect(() => {
    if (searchText?.length) setPage(1);
  }, [searchText]);

  const getBlockList = (event) => {
    api.getWithToken(`${serverURL}blog/?page=${page}${searchText ? `&_s=${searchText}` : ""}`)
      .then(async (res) => {
        const { data, links, page, page_size, total, total_pages } = res?.data;
        setPaginationData({ links, page, page_size, total, total_pages })
        setLoading(false)
        if (res?.data?.success === true) {
          setData(data);
        }
      })
      .catch((e) => {
        setLoading(false)
      });
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "banner_image") {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImage(reader.result);
        };
        reader.readAsDataURL(file);
        setStates({
          ...states,
          [name]: file,
        });
      }
    } else
      setStates((prevValues) => ({
        ...prevValues,
        [name]: value.trimStart(),
      }));
  };

  const handleSubmit = (event) => {
    setSubLoader(true)
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity()) {
      setValidated(false);
      const type = Boolean(mode) ? "postWithToken" : "putWithToken";
      const formData = new FormData();
      formData.append("title", states?.title);
      formData.append("short_description", states?.short_description);
      formData.append("description", states?.description);
      formData.append("banner_image", states?.banner_image);
      if (states?.id)
        formData.append("id", states?.id);

      api[type](`${serverURL}blog/`, formData)
        .then(async (res) => {
          setModalShow(false)
          setStates({})
          form.reset();
          getBlockList();
          setSubLoader(false)
          if (res?.data?.success === true) {
            toast.success(res?.data?.message);

          } else if (res?.data?.success === false) {
            if (typeof res?.data?.message === "string")
              toast.error(res?.data?.message);
          }
        })
        .catch((e) => {
          setSubLoader(false)
          errorResponse(e);
        });
    } else {
      setValidated(true);
      setSubLoader(false)
      event.stopPropagation();
    }
  };

  const deleteBlogList = () => {
    setSubLoader(true)
    api.deleteWithToken(`${serverURL}blog/${deleteData}`)
      .then(async (res) => {
        setDeleteModalShow(false)
        setSubLoader(false)
        if (res?.data?.success === true) {
          toast.success(res?.data?.message);
          getBlockList()
        } else if (res?.data?.success === false) {
          if (typeof res?.data?.message === "string")
            toast.error(res?.data?.message);
        }
      })
      .catch((e) => {
        setSubLoader(false)
        errorResponse(e);
      });
  };

  const editorConfiguration = {
    extraPlugins: [CustomAdapterPlugin],
    mediaEmbed: {
      previewsInData: true,
    },

    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "blockQuote",
        "|",
        "imageUpload",
        "|",
        "mediaEmbed",
        "|",
        "imageTextAlternative",
        // ... any other toolbar items except 'insertTable'
      ],
    },

    image: {
      toolbar: [
        "imageStyle:full",
        "imageStyle:side",
        "|",
        "imageTextAlternative",
      ],
      resizeUnit: "px",
    },
  };

  function CustomAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new CustomUploadAdapter(loader, setSubLoader); // Pass the setLoading function
    };
  }

  const finalContent = `<!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
     
      <style>
      .custom-html body {
          padding: 20px;
      }
      .custom-html figure img {
          width: 100%;
          height: 100%;
      }
      .custom-html p {
          word-break: break-all;
          font-size: 14px;
          color: #555;
          font-weight: 500;
      }
      .custom-html ul {
          padding: 0px;
      }
      .custom-html ul {
        padding: 0px;
    }
    .custom-html blockquote {
      border-left: 5px solid #ccc;
      font-style: italic;
      margin-left: 0;
      margin-right: 0;
      overflow: hidden;
      padding-left: 1.5em;
      padding-right: 1.5em;
  }
    .custom-html strong {
      font-weight: 900;
    }
       .custom-html h1,
       .custom-html h2,
       .custom-html h3,
       .custom-html h4,
       .custom-html h5,
       .custom-html h6 {
          margin-top: 15px;
      }
      
      .custom-html ul li {
        font-size: 14px;
        color: #555;
        font-weight: 500;
        margin-left: 1.5rem !important;
      }

      .custom-html body::-webkit-scrollbar{
          display:none;
      }
  </style>

  </head>
  <body>
  ${viewData?.description}
  </body>
  </html>
  `;

  return (
    <>

      <Card className="user-list">
        <Card.Header>
          <div className='d-flex justify-content-between align-items-center'>
            <Card.Title as="h4">{props?.title || ""}</Card.Title>
            <div className='d-flex align-items-center'>
              <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                <NavSearch searchText={searchText} setSearchText={setSearchText} />
              </header>
              <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({}); setModalShow(true) }}>
                {"Add"}
              </Button>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table responsive hover className='product-table'>
            <thead>
              <tr>
                <th>No</th>
                <th>Banner Image</th>
                <th>Title</th>
                <th>Short Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Boolean(loading) ?
                <tr>
                  <td colSpan={6} className='text-center'>
                    <Loader loading={loading} />
                  </td>
                </tr>
                :
                Boolean(data?.length) ? data?.map((item, index) =>
                  <tr key={index + "blogList cursor-pointer"} onClick={() => { setViewData(item); setViewModalShow(true) }}>
                    <td>{(10 * (page - 1)) + (index + 1)}</td>
                    <td>
                      <img style={{ width: '40px' }} src={item?.banner_image} alt="activity-user" />
                    </td>
                    <td>
                      <h6 className="m-0">{item?.title || ""}</h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.short_description || ""}</h6>
                    </td>
                    <td>
                      <div className='d-flex align-items-center gap-3'>
                        <div className='cursor-pointer' onClick={(e) => { e?.stopPropagation(); setMode(false); setStates(item); setModalShow(true) }}>
                          <i className="feather icon-edit" title='Edit' />
                        </div>
                        <div className='cursor-pointer' onClick={() => { e?.stopPropagation(); setDeleteData(item?.id); setDeleteModalShow(true) }}>
                          <i className="feather icon-trash-2" title='Delete' />
                        </div>
                      </div>
                    </td>
                  </tr>
                )
                  :
                  <tr>
                    <td colSpan={6} className='text-center'>
                      There are no records available at the moment.
                    </td>
                  </tr>
              }
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {Boolean(data?.length) && paginationData?.total_pages > 1 &&
        <PaginationC data={paginationData}
          onPageChange={(newPage) => {
            setPage(newPage);
          }} />
      }

      {/* add modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {Boolean(subLoader) && <Loader loading={subLoader} />}
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center'>
              <Card.Title as="h5">Add {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className={`mb-3 ${!Boolean(mode) && "align-items-center"}`} as={Row} controlId="formHorizontalFirstName">
                  <Form.Label column sm={3}>
                    Banner Image
                  </Form.Label>
                  <Col sm={9}>
                    <div className="position-relative" id="profile_image">
                      <div className="d-flex">
                        <img
                          src={selectedImage || states?.banner_image}
                          onClick={handleImageClick}
                          className={`cursor-pointer profile-image`}
                        />
                      </div>
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png, webm, .webp"
                        name="banner_image"
                        style={{ display: "none" }}
                        ref={fileInputRef}
                        onChange={handleChange}
                      />

                      <img
                        src={camera}
                        onClick={handleImageClick}
                        className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                        alt=""
                      />
                    </div>

                  </Col>
                </Form.Group>

                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                  <Form.Label column sm={3}>
                    Title
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="text" placeholder="Enter title here" required value={states?.title || ""} name='title' onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">Please enter title.</Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                  <Form.Label column sm={3}>
                    Short Description
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="text" placeholder="Enter short description here" required value={states?.short_description || ""} name='short_description' onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">Please enter short description.</Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                  <Form.Label column sm={3}>
                    Description
                  </Form.Label>
                  <Col sm={9}>
                    <CKEditor
                      name="content"
                      editor={ClassicEditor}
                      data={states?.description || ""}
                      onChange={debounce((event, editor) => {
                        setStates((prevState) => ({
                          ...prevState,
                          description: editor?.getData() || "",
                        }));
                      }, 300)}
                      config={editorConfiguration}
                    />
                    <Form.Control.Feedback type="invalid">Please enter product shape name.</Form.Control.Feedback>
                  </Col>
                </Form.Group>


                <div className='d-flex justify-content-end'>
                  <Button type='submit' className='m-0'>Save</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      {/* edit Modal */}
      <Modal
        show={editModalShow}
        onHide={() => setEditModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {Boolean(subLoader) && <Loader loading={subLoader} />}
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center'>
              <Card.Title as="h5">Edit {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Group className="mb-4" as={Row} controlId="formHorizontalFirstName">
                  <Form.Label column sm={3}>
                    FirstName
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="text" placeholder="Enter FirstName" />
                  </Col>
                </Form.Group>

                <Form.Group className="mb-4" as={Row} controlId="formHorizontalLastName">
                  <Form.Label column sm={3}>
                    LastName
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="text" placeholder="Enter LastName" />
                  </Col>
                </Form.Group>

                <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={3}>
                    Email
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="email" placeholder="Email" />
                  </Col>
                </Form.Group>

                <Form.Group className="mb-4" as={Row} controlId="formHorizontalUsername">
                  <Form.Label column sm={3}>
                    Username
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control type="text" placeholder="Enter Username" />
                  </Col>
                </Form.Group>

                <div className='d-flex justify-content-end'>
                  <Button onClick={() => setModalShow(false)} className='m-0'>Save</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      {/* Delete */}
      <Modal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {Boolean(subLoader) && <Loader loading={subLoader} />}
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
              <Card.Title as="h5">Delete {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body className='pb-2'>
              <h6>Are you sure you want to delete?</h6>
              <div className='d-flex justify-content-center'>
                <Button onClick={() => deleteBlogList()} className='mt-3 mb-0 mx-0'>Delete</Button>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        show={viewModalShow}
        onHide={() => setViewModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center'>
              <Card.Title as="h5">{"View "} {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body>

              <div className="d-flex justify-content-between w-100 pl-4">
                <table>
                  <tr>
                    <td>
                      <p className='text-black fs-6 fw-bolder mb-2'>Blog Banner Image :</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className='border rounded-2 p-2 d-inline-block'>
                        <img src={viewData?.banner_image} width={200} height={200} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p className='text-black fs-6 fw-bolder mb-2 mt-3'>Title:</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {viewData?.title || "-"}
                    </td>
                  </tr>
                  <tr>
                    <p className='text-black fs-6 fw-bolder mb-2 mt-3'>Short Description:</p>
                  </tr>
                  <tr>
                    <td>
                      {viewData?.short_description || "-"}
                    </td>
                  </tr>
                  <tr>
                    <p className='text-black fs-6 fw-bolder mb-2 mt-3'>Description:</p>
                  </tr>
                  <tr>
                    <td>
                      <div
                        className="custom-html"
                        dangerouslySetInnerHTML={{ __html: finalContent }}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Blogs